import React from 'react';
import Overlay from 'Components/Overlay/index';
import moment from 'moment';

export const SeaDetails = (props) => (
    <Overlay>
        <div className="bg-white box-shadow ph-20 pv-20 br-100 pr-40">
            <div className="mb-20 tleft header-medium-color fBold fs-18 border-bottom-light pb-10">Container Details
                <span className="pr-10 fRight curP" id='close' onClick={props.onClose}>x</span> 
            </div>
            <div className="wt-900">
                <div className="flex flex-between ph-10">
                    <div><span>{'Conatiner No.: '}</span><span className="fBold">{props.seaData.container_number || props.seaData.number}</span></div>
                    <div><span>{'Route: '}</span><span className="fBold">{(props.seaData.events[0].name)} {'-'} {props.seaData.events[props.seaData.events.length - 1].name}</span></div>
                </div>
            </div>
            <div className="courier-table details-popUp pv-10 ph-10">
                <table cellPadding="0" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Location</th>
                            <th>Arrival Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(props.seaData.events || []).map((el, index) => {
                            const numberOflist = (props.seaData.events || []).filter(list => list.location === el.location);
                            const findIndex = (props.seaData.events || []).findIndex(list => list.location === el.location);
                        return(
                            <tr>
                                {findIndex === index && <td style={{'borderBottom': '1px solid grey'}} rowSpan={numberOflist.length}>{el.name}</td>}
                                <td style={{'borderBottom': '1px solid grey'}}><span className={el.actual ? 'green-color fBold' :'orange-color fBold'}>{el.date && moment(el.date).format('DD MMM YYYY HH:mm:SS')}</span></td>
                                <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>{el.description}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
        </div>
    </Overlay>
)